import * as React from 'react';
export const IcYoga = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.47 19.07l3.63-1L6.26 17a1.033 1.033 0 00-.52 2l.59.17a.845.845 0 01.14-.1zM12 8a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-2 3.62V17l2 .54 2-.54v-5.4a5.5 5.5 0 003.5-5.1 5.44 5.44 0 00-2.11-4.29 1.001 1.001 0 10-1.23 1.58A3.43 3.43 0 0115.5 6.5a3.5 3.5 0 11-7 0 3.43 3.43 0 011.34-2.71 1.002 1.002 0 00-1.23-1.58A5.44 5.44 0 007.46 9.6 5.5 5.5 0 0010 11.62zm9 6.12a1 1 0 00-1.22-.7l-11 3A1 1 0 006 21.26 1 1 0 007 22a.747.747 0 00.26 0l11-3a1 1 0 00.74-1.26zm-1.39 2.45l-3.67 1 2.84.77A.779.779 0 0017 22a1 1 0 001-.74 1 1 0 00-.43-1.07h.04z'
      fill='currentColor'
    />
  </svg>
);
